import get from 'lodash/get';
import siteData from '../site_data_util';
import striptags from 'striptags';
import baseSeoUtil from '../base_seo_util';

export default function(state = {}, action = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const wpTitle = get(action, 'brandsThatMatterPage.title.rendered');
  const img = get(
    action,
    'brandsThatMatterPage._embedded.wp:featuredmedia[0].source_url'
  );
  const wpExcerpt = get(action, 'brandsThatMatterPage.excerpt.rendered');
  const socialTitle = wpTitle ? striptags(wpTitle).trim() : ''; // displays for twitter and social platforms
  const seoTitle = get(action, 'brandsThatMatterPage.acf.title'); // displays on google and browser tab
  const description = wpExcerpt ? striptags(wpExcerpt).trim() : '';
  const url = `https://www.fastcompany.com/brands-that-matter/2021`;

  return baseSeoUtil({
    site,
    siteConf,
    title: seoTitle,
    url,
    description,
    image: img,
    articleSection: 'Brands That Matter',
    config: get(state, 'config'),
    facebookTitleOverride: `${socialTitle} | Fast Company`,
    twitterTitleOverride: `${socialTitle} | Fast Company`
  });
}
